import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchCorneaRetrievalPlan = async (lng = "english", params = {}) => {
  try {
    const user = await getStorage();
    const res = await api({
      method: "GET",
      url: `${API_URL}/corneaRetrievalPlan`,
      params,
      headers: { Authorization: `Bearer ${user.token}` },
    });
    return res.data;
  } catch (error) {
    toastMessage("error", "Unable to fetch cornea retrieval plan");
  }
};

export const createCorneaRetrievalPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/corneaRetrievalPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const updateCorneaRetrievalPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/corneaRetrievalPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const recordCorneaPerformance = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/corneaRetrievalPlan/perform`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const deleteCorneaRetrievalPlan = async (lng = "english", id) => {
  const user = await getStorage();
  return api({
    method: "DELETE",
    url: `${API_URL}/corneaRetrievalPlan`,
    data: { id },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export default fetchCorneaRetrievalPlan;
